module.exports = __webpack_public_path__ + "img/project_4.98885c98.jpg";